/**
 * Các type đồng bộ 
 * nxhinh 21/06/2024
 */
export default {
    Case1: 1,
    Case2: 2,
    Case3: 3,
    Case4: 4,
    Case5: 5,
  };